// @ts-nocheck
import * as React from 'react';
import AIRecommendations from './AIRecommendations';
import FeatureDemoCards from './FeatureDemoCards';
import './FamilyBanner.css';

export default function WorkbenchV2({ parent, ranked, demos, onTrigger, aiOn }) {
  return (
    <section className="A-col A-col--bench A2-bench">
      <AIRecommendations parent={parent} topPicks={ranked} />

      <div className="A2-feat-head">
        <div className="A2-feat-head__title">
          <span className="A2-feat-head__title-eyebrow">AI Created</span>
          <span>Customized Demo For Your Child</span>
        </div>
        <span className="A2-feat-head__hint">Click any to trigger a live demo</span>
      </div>

      <FeatureDemoCards ranked={ranked} demos={demos} onTrigger={onTrigger} aiOn={aiOn} content={parent.content} />
    </section>
  );
}
